import { Component, Output, EventEmitter, Input } from '@angular/core';
import { CustomQualification } from 'src/app/models/custom-qualification';
import { MasterQualification } from 'src/app/models/master-qualification';
import { RequestTypeQualification } from 'src/app/models/requesttypequalification';
import { ServiceQualResponse } from 'src/app/models/service-qual-response';
import { ServiceQualification } from 'src/app/models/service-qualification';
import { ServiceRequest } from 'src/app/models/service.request';
import { QualificationService } from 'src/app/services/qualifications.service';
import { ServiceRequestsService } from 'src/app/services/service-requests.service';
import { Settings } from 'src/app/services/settings';
import { InputNumberModule } from 'primeng/inputnumber';
import { CaseQualResponse } from 'src/app/models/caseQualResponse';
import { Case } from "../../../models/case";

@Component({
	selector: 'app-qualification-responses',
	templateUrl: './qualification-responses.component.html',
	styleUrls: ['./qualification-responses.component.css']
})
export class QualificationResponsesComponent {

	@Output() editEvent = new EventEmitter<any>();
	public _serviceRequest: ServiceRequest;
	public isEditing = false;
	public strErr = '';
	public inpValue: number;
	public customQualificationsForAgency: CustomQualification[];
	public customQualificationsAll: CustomQualification[];
	public masterQualificationsAll: MasterQualification[];
	public masterQualificationsMappingList: RequestTypeQualification[];
	public serviceQualificationsMappingList: ServiceQualification[];
	public serviceQualResponseList: ServiceQualResponse[];
	public caseQualResponseList: CaseQualResponse[];
	public _caseRecord: Case = null;

	public qualificationsList: any;
	public showHistoricQuestions = false;
	public historicalResponses: any;

	public _calledFrom: string = 'requests';
	caseId: number;


	@Input() set calledFrom(val: string) {
		this._calledFrom = val;
	}

	@Input() set caseRecord(val: Case) {
		this._caseRecord = val;
	}

	showQualifications = false;
	enableQuestionsFromPreviousAgencies = false;
	editResponsesMyAgency = false;
	editMasterResponses = false;
	viewQualificationsOfMyAgency = false;
	viewMasterQualifications = false;


	constructor(private serviceRequestsService: ServiceRequestsService,
		private qualificationService: QualificationService) {
		this.serviceQualResponseList = [];
	}
	setSecurityPrivileges() {
		if (this._calledFrom === 'cases') {
			this.showQualifications = Settings.getInstance().hasPrivilege('CLIENTS_CASE_DETAILS_QUALIFICATIONS', "EXECUTE");
			this.enableQuestionsFromPreviousAgencies = Settings.getInstance().hasPrivilege('CLIENTS_CASE_DETAILS_QUALIFICATIONS_SHOW_PREV_AGENCY', "SHOW");
			this.editResponsesMyAgency = Settings.getInstance().hasPrivilege('CLIENTS_CASE_DETAILS_QUALIFICATIONS_SHOW_MY_AGENCY_ONLY', "EXECUTE");
			this.editMasterResponses = Settings.getInstance().hasPrivilege('CLIENTS_CASE_DETAILS_QUALIFICATIONS_EDIT_RESPONSE', "EXECUTE");
			this.viewQualificationsOfMyAgency = Settings.getInstance().hasPrivilege('CLIENTS_CASE_DETAILS_QUALIFICATIONS_SHOW_MY_SERVICE_QUALIFICATIONS', "SHOW");
			this.viewMasterQualifications = Settings.getInstance().hasPrivilege('CLIENTS_CASE_DETAILS_QUALIFICATIONS_SHOW_MASTER_QUALIFICATIONS', "SHOW");

		} else {
			this.showQualifications = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_QUALIFICATIONS', "EXECUTE");
			this.enableQuestionsFromPreviousAgencies = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_QUALIFICATIONS_SHOW_PREV_AGENCY', "SHOW");
			this.editResponsesMyAgency = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_QUALIFICATIONS_SHOW_MY_AGENCY_ONLY', "EXECUTE");
			this.editMasterResponses = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_QUALIFICATIONS_EDIT_RESPONSE', "EXECUTE");
			this.viewQualificationsOfMyAgency = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_QUALIFICATIONS_SHOW_MY_SERVICE_QUALIFICATIONS', "SHOW");
			this.viewMasterQualifications = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_QUALIFICATIONS_SHOW_MASTER_QUALIFICATIONS', "SHOW");
		}

	}
	public onShowHandler(serviceRequest: ServiceRequest, caseId) {
		this._serviceRequest = serviceRequest;
		this.caseId = caseId;
		this.setSecurityPrivileges();
		this.queryRecords();
	}
	public queryRecords() {
		if (this._calledFrom === 'cases') {
			this.queryRecordsForCasesWorkspace();
		} else {
			this.queryRecordsForRequestWorkspace();
		}
	}
	public queryRecordsForRequestWorkspace() {
		this.qualificationService.getAllMasterQualifications().subscribe(
			(result1) => {
				this.masterQualificationsAll = result1.filter(s => s.activeStatus === 'Active');;
				this.qualificationService.getAllCustomQualificationsByAgencyId(Settings.getInstance().loggedInUser.agencyId).subscribe(
					(result2) => {
						this.customQualificationsForAgency = result2.filter(s => s.activeStatus === 'Active');;
						this.qualificationService.getAllRequestTypeQualificationsByRequestTypeId(this._serviceRequest.serviceRequestTypeId).subscribe(
							(result3) => {
								this.masterQualificationsMappingList = result3;
								this.qualificationService.getAllServiceQualificationsByServiceDefId(this._serviceRequest.serviceDefId).subscribe(
									(result4) => {
										this.serviceQualificationsMappingList = result4;
										this.qualificationService.getAllServiceQualResponsesByServiceRequestId(this._serviceRequest.id).subscribe(
											(result5) => {
												this.serviceQualResponseList = result5;
												this.qualificationService.getAllCustomQualifications().subscribe(
													(result6) => {
														this.customQualificationsAll = result6;
														this.qualificationService.getAllCaseQualResponsesByCaseId(this.caseId).subscribe(
															(result7) => {
																this.caseQualResponseList = result7;
																this.prepareQualificationsListsAndDisplay();
															},
															(error7) => {
																Settings.getInstance().handleError(error7, 'Error: unable to retrieve case qual responses data from the service');
															}
														);
													},
													(error6) => {
														Settings.getInstance().handleError(error6, 'Error: unable to CustomQualifications definitions from the service');
													}
												);
											},
											(error5) => {
												Settings.getInstance().handleError(error5, 'Error: unable to retrieve qual responses data from the service');
											}
										);
									},
									(error4) => {
										Settings.getInstance().handleError(error4, 'Error: unable to retrieve mapping data from the service');
									}
								);

							},
							(error3) => {
								Settings.getInstance().handleError(error3, 'Error: unable to retrieve  data from the service');
							}
						);
					},
					(error2) => {
						Settings.getInstance().handleError(error2, 'Error: unable to retrieve  data from the service');
					}
				);
			},
			(error1) => {
				Settings.getInstance().handleError(error1, 'Error: unable to retrieve  data from the service');

			}
		);
	}

	public queryRecordsForCasesWorkspace() {
		this.qualificationService.getAllMasterQualifications().subscribe(
			(result1) => {
				this.masterQualificationsAll = result1.filter(s => s.activeStatus === 'Active');
				this.qualificationService.getAllCaseQualResponsesByCaseId(this.caseId).subscribe(
					(result7) => {
						this.caseQualResponseList = result7;
						this.prepareQualificationsListsAndDisplay();
					},
					(error7) => {
						Settings.getInstance().handleError(error7, 'Error: unable to retrieve case qual responses data from the service');
					}
				);
			},
			(error1) => {
				Settings.getInstance().handleError(error1, 'Error: unable to retrieve  data from the service');

			}
		);

	}
	public prepareQualificationsListsAndDisplay() {
		this.qualificationsList = [];

		if (!this.customQualificationsForAgency) {
			this.customQualificationsForAgency = [];
		}
		if (!this.serviceQualificationsMappingList) {
			this.serviceQualificationsMappingList = [];
		}

		if (this.viewMasterQualifications) {
			if (!this.masterQualificationsMappingList) {
				for (const rec of this.masterQualificationsAll) {
					let assigned = rec;
					assigned['masterFlag'] = true;
					assigned['masterQualificationId'] = rec.id;
					this.qualificationsList.push(assigned);
				}
			} else {
				for (const rec of this.masterQualificationsMappingList) {
					let assigned = rec;
					const masterQualifyRecord = this.getMasterQualificationRecordById(assigned.masterQualificationId);

					if (masterQualifyRecord.id === 0) {
						continue;
					}

					for (const mapping of this.serviceQualificationsMappingList) {
						if (rec.masterQualificationId === mapping.masterQualificationId) {
							assigned['sequence'] = mapping.sequence;
						}
					}

					assigned['masterFlag'] = true;
					assigned['question'] = masterQualifyRecord.question;
					assigned['description'] = masterQualifyRecord.description;
					assigned['masterQualificationId'] = masterQualifyRecord.id;
					this.qualificationsList.push(assigned);
				}
			}

		}

		if (this.viewQualificationsOfMyAgency) {
			for (const rec of this.customQualificationsForAgency) {
				let assigned = rec;
				for (const mapping of this.serviceQualificationsMappingList) {
					if (rec.id === mapping.customQualificationId) {
						assigned['sequence'] = mapping.sequence;
						assigned['required'] = mapping.required;
						assigned['masterFlag'] = false;
						assigned['customQualificationId'] = mapping.customQualificationId;
						assigned['description'] = rec.description;
						this.qualificationsList.push(assigned);
					}
				}
			}
		}

		this.qualificationsList.sort((a, b) => a.sequence - b.sequence);
		this.displayQualResponseData();
	}

	public displayQualResponseData() {
		let table = '';
		let key = '';
		for (const rec of this.qualificationsList) {
			let response: any;
			if (rec['masterFlag'] === true) {
				response = this.getCaseQualResponseRecord(rec['masterQualificationId']);
			} else {
				table = 'CustomQualifications';
				key = rec['customQualificationId'];
				response = this.getQualResponseRecord(Settings.getInstance().loggedInUser.agencyId, table, key + '');
			}

			if (response) {
				rec['value'] = response.response;
				rec['qualResponseId'] = response.id;
				if (rec.controlType === 'Date') {
					rec['value'] = new Date(response.response);
				}
			}
		}
		//console.log(this.qualificationsList);
		this.loadHistoricalResponses();

	}
	public loadHistoricalResponses() {
		this.historicalResponses = [];
		for (const rec of this.serviceQualResponseList) {
			if (rec.agencyId === this._serviceRequest.agencyId) {
				continue;
			}
			if (rec.foreignKeyTable === 'MasterQualifications') {
				continue; //Asuming that master qualification responses are not agency specific.
			} else {
				const customQual: CustomQualification = this.getCustomQualificationRecordById(parseInt(rec.foreignKeyId));
				rec['description'] = customQual.description;
				if (customQual.controlType === 'Date') {
					try {
						rec['response'] = rec['response'].substring(0, 10)
					} catch { }
				}
			}
			this.historicalResponses.push(rec);
		}
	}
	public getQualResponseRecord(agencyId: number, table: string, key: string) {
		for (const rec of this.serviceQualResponseList) {
			if (rec.agencyId === agencyId && rec.foreignKeyTable === table && rec.foreignKeyId === key) {
				return rec;
			}
		}
		return undefined;
	}
	public getCaseQualResponseRecord(parmMasterQualificationId: number) {
		for (const rec of this.caseQualResponseList) {
			if (rec.masterQualificationsId === parmMasterQualificationId) {
				return rec;
			}
		}
		return undefined;
	}
	public getMasterQualificationRecordById(id: number) {
		for (const rec of this.masterQualificationsAll) {
			if (rec.id === id) { return rec; }
		}
		return new MasterQualification();
	}
	public getCustomQualificationRecordById(id: number) {
		for (const rec of this.customQualificationsAll) {
			if (rec.id === id) { return rec; }
		}
		return new CustomQualification();
	}
	public editRecord() {
		this.isEditing = true;
		this.editEvent.emit(this.isEditing);
	}
	public cancelSubmitRecord() {
		this.isEditing = false;
		this.editEvent.emit(this.isEditing);
		this.strErr = '';
		this.queryRecords();
	}
	public validateResponses(): boolean {
		let retVal: boolean = true;
		for (const item of this.qualificationsList) {

			/*** Note that Master records cannot be edited by Request users so if there
			* is anything missing,  just skip over it
			***/

			if ((item.masterFlag === true) && (this.editMasterResponses === false)) {
				continue;
			}

			if (item.required === 1 && (item.value === undefined || item.value === null || item.value === '')) {
				this.strErr = 'Response required: ' + item.question;
				retVal = false;
				break;
			}
		}
		return retVal;
	}
	public async submitRecord() {
		this.strErr = '';
		if (!this.validateResponses()) {
			return;
		}
		try {
			const promises = this.qualificationsList.map(async (rec) => {
				let masterQualResponseRecord: CaseQualResponse;
				let responseRecord: ServiceQualResponse;
				if (rec['masterFlag']) {
					masterQualResponseRecord = {
						id: rec['qualResponseId'] || 0,
						caseId: this.caseId,
						masterQualificationsId: rec['masterQualificationId'],
						questionText: rec['question'],
						response: rec['value'],
						dateRecorded: new Date(),
						recordedBy: Settings.getInstance().loggedInUser.username,
					};
				} else {
					responseRecord = {
						recordedBy: Settings.getInstance().loggedInUser.username,
						response: rec['value'],
						questionText: rec['question'],
						required: rec['required'],
						serviceRequestId: this._serviceRequest.id,
						agencyId: Settings.getInstance().loggedInUser.agencyId,
						foreignKeyTable: rec['masterFlag'] ? 'MasterQualifications' : 'CustomQualifications',
						foreignKeyId: rec['masterFlag'] ? rec['masterQualificationId'] : rec['customQualificationId'],
						id: rec['qualResponseId'] || 0,
						dateRecorded: new Date()
					};
				}

				if (rec['qualResponseId'] && rec['qualResponseId'] > 0) {
					if (rec['masterFlag']) {
						await this.qualificationService.updateCaseQualResponse(masterQualResponseRecord).toPromise();
					} else {
						await this.qualificationService.updateServiceQualResponse(responseRecord).toPromise();
					}
				} else {
					if (rec['masterFlag']) {
						await this.qualificationService.createCaseQualResponse(masterQualResponseRecord).toPromise();
					} else {
						await this.qualificationService.createServiceQualResponse(responseRecord).toPromise();
					}
				}
			});

			// Wait for all promises to resolve
			await Promise.all(promises);

			// All records have been created/updated, set isEditing to false
			this.isEditing = false;
			this.editEvent.emit(this.isEditing);
			this.strErr = '';
		} catch (error) {
			Settings.getInstance().handleError(error, 'Error: unable to save data');
		}
	}

}
